import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCart } from "@/contexts/CartContext";

const CartButton = ({ className = "" }: { className?: string }) => {
  const { itemCount } = useCart();
  const [bump, setBump] = useState(false);

  useEffect(() => {
    const onBump = () => {
      setBump(true);
      window.setTimeout(() => setBump(false), 450);
    };
    window.addEventListener("bag:bump", onBump);
    return () => window.removeEventListener("bag:bump", onBump);
  }, []);

  return (
    <Link
      to="/cart"
      data-bag-icon
      aria-label={`View bag${itemCount > 0 ? ` (${itemCount} item${itemCount === 1 ? "" : "s"})` : ""}`}
      className={`relative p-2 text-dark-foreground hover:text-blood-red transition-colors duration-300 ${className}`}
    >
      <ShoppingBag className={`w-5 h-5 transition-transform duration-300 ${bump ? "scale-125" : "scale-100"}`} />
      {itemCount > 0 && (
        <span
          key={itemCount}
          className={`absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-blood-red text-white text-[10px] font-semibold flex items-center justify-center animate-scale-in ${
            bump ? "scale-110" : "scale-100"
          } transition-transform duration-300`}
        >
          {itemCount > 99 ? "99+" : itemCount}
        </span>
      )}
    </Link>
  );
};

export default CartButton;
